export enum SlotType {
  ARRIVAL = 'arrival',
  DEPARTURE = 'departure',
  SHUNTING = 'shunting',
}

export enum StationType {
  FREIGHT_TERMINAL = 'FREIGHT_TERMINAL',
  PASSENGER = 'PASSENGER',
  MIXED = 'MIXED',
  SIDING = 'SIDING',
  PORT_TERMINAL = 'PORT_TERMINAL',
  INLAND_TERMINAL = 'INLAND_TERMINAL',
  BORDER_CROSSING = 'BORDER_CROSSING',
}

export enum StationSource {
  OSM = 'OSM',
  UTK = 'UTK',
  MANUAL = 'MANUAL',
}

export enum LineCategory {
  TRUNK = 'TRUNK',
  MAIN = 'MAIN',
  SECONDARY = 'SECONDARY',
  LOCAL = 'LOCAL',
}

export enum GpsAdapterType {
  GBOX = 'GBOX',
  TRIMBLE = 'TRIMBLE',
  MQTT_GENERIC = 'MQTT_GENERIC',
  WEBHOOK_GENERIC = 'WEBHOOK_GENERIC',
  MANUAL = 'MANUAL',
}

export enum CimWaybillType {
  CIM = 'CIM',
  CIM_SMGS = 'CIM_SMGS',
  ECIM = 'ECIM',
}

export enum CimStatus {
  DRAFT = 'DRAFT',
  ISSUED = 'ISSUED',
  SIGNED = 'SIGNED',
  IN_TRANSIT = 'IN_TRANSIT',
  DELIVERED = 'DELIVERED',
  CANCELLED = 'CANCELLED',
  AMENDED = 'AMENDED',
}

export enum ChargesPaidBy {
  CONSIGNOR = 'CONSIGNOR',
  CONSIGNEE = 'CONSIGNEE',
  THIRD_PARTY = 'THIRD_PARTY',
}

export enum RidPackingGroup {
  I = 'I',
  II = 'II',
  III = 'III',
}

export enum CimSignatureMethod {
  ESEAL = 'ESEAL',
  QUALIFIED = 'QUALIFIED',
  HANDWRITTEN_SCAN = 'HANDWRITTEN_SCAN',
}

export enum RailCargoType {
  CONTAINER = 'CONTAINER',
  INTERMODAL = 'INTERMODAL',
  BULK = 'BULK',
  GENERAL = 'GENERAL',
}

export enum IsoContainerSize {
  ISO_20 = 'ISO_20',
  ISO_40 = 'ISO_40',
  ISO_40HC = 'ISO_40HC',
  ISO_45 = 'ISO_45',
}
